import { capitalizeString } from 'utils/format';

export function getStyle(template, styleName) {
  const { styles } = template.template;

  if (!styles || !styleName) {
    return {};
  }

  const [category, name] = styleName.split('.');
  if (!category || !name) {
    return {};
  }

  if (!styles[category]) {
    return {};
  }

  if (!styles[category][name]) {
    return {};
  }

  return styles[category][name];
}

export function getTemplateStyleCategories(template) {
  return Object.keys(template.template.styles ?? {});
}

export function getTemplateStyles(template, type, category = undefined) {
  const styleCategories = getTemplateStyleCategories(template);
  if (styleCategories.length < 1) {
    return [];
  }

  let categoryName;
  if (template.template.styles[category]) {
    categoryName = category;
  } else {
    categoryName = styleCategories[0];
  }

  const styles = Object.entries(template.template.styles[categoryName]).reduce(
    (acc, [key, style]) => {
      if (style.type === type) {
        acc.push({
          ...style,
          name: key,
          category: categoryName,
          label: capitalizeString(key.replace('_', ' ')),
        });
      }

      return acc;
    },
    [],
  );

  return styles;
}
